import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import type { NavigationService } from 'src/services/NavigationService';
import { WebNavigationServiceImpl } from 'src/services/NavigationService/WebNavigationServiceImpl';
import { WorkspaceNavigationGuardServiceImpl } from 'src/services/WorkspaceNavigationGuardService/impl';
import type { ReactBindings } from 'src/types/bindings';

export const webNavigationModule = new TypedContainerModule<ReactBindings>((bind) => {
    bind('WebNavigationHost').to(WebNavigationServiceImpl).inSingletonScope();
    bind('NavigationService').toService('WebNavigationHost');
    bind('NavigationServiceProvider').toProvider<NavigationService>((context) => () => {
        return Promise.resolve(context.container.get<NavigationService>('NavigationService'));
    });
    bind('WorkspaceNavigationGuardService').to(WorkspaceNavigationGuardServiceImpl).inSingletonScope();
});
